import PropTypes from "prop-types"
import { Controller } from "react-hook-form"

import Select from "components/ui/select"

const GiftCardSelect = ({ control, id, name, options }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Select className="border-none" id={id} {...field}>
          {options.map((time) => {
            let value = time
            let text = time
            if (id === "timezone_gift_card") {
              value = time[1]
              text = time[0]
            }
            return (
              <option key={text} value={value}>
                {text}
              </option>
            )
          })}
        </Select>
      )}
    />
  )
}

GiftCardSelect.propTypes = {
  control: PropTypes.object.isRequired,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
}

export default GiftCardSelect
